/**
 * The bits of WCAG contrast the app needs at runtime, for colours the user picks.
 * Named colours are checked at build time instead (packages/tokens/contrast.mjs).
 */
const channel = (c: number) => (c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4);

/** Relative luminance, 0 (black) to 1 (white), of a `#rrggbb` colour. */
export function luminance(hex: string) {
  const [r, g, b] = [1, 3, 5].map((i) => channel(parseInt(hex.slice(i, i + 2), 16) / 255)) as [number, number, number];
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

export const contrast = (a: string, b: string) => {
  const [hi, lo] = [luminance(a), luminance(b)].sort((x, y) => y - x) as [number, number];
  return (hi + 0.05) / (lo + 0.05);
};

/**
 * Above this, ink reads on the colour; below it, white does. Either choice clears 3:1 at the boundary,
 * so there is no luminance where the text on a fill falls short.
 */
const INK_ABOVE = 0.3;
export const readableOn = (hex: string) => (luminance(hex) > INK_ABOVE ? '#17171A' : '#FFFFFF');
